import { Box, GridDirection } from "@mui/material";
import { MenuDataItem } from "./list";
import MenuElement from "./MenuElement";
import MenuElementChildren from "./MenuElementChildren";
import { Can } from "../../permission/Can";

interface MenuBasicProps {
  options: Array<MenuDataItem>;
  direction?: GridDirection;
}

const MenuBasic = ({ options, direction: directionProps }: MenuBasicProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: directionProps ? directionProps : "row",
        paddingTop: {
          lg: "0px",
          md: "30px",
          sm: "30px",
          xs: "30px",
        },
      }}
    >
      {Object.entries(options).map(([key, menuElement]) => (
        <Can I="view" key={menuElement.entity} this={menuElement.entity}>
          {menuElement.link ? (
            <MenuElement
              key={key}
              id={menuElement.entity}
              label={menuElement.label}
              url={menuElement.link}
              blank={false}
            />
          ) : menuElement.externalLink ? (
            <MenuElement
              key={key}
              id={menuElement.entity}
              label={menuElement.label}
              url={menuElement.externalLink}
              blank={true}
            />
          ) : menuElement.children ? (
            <MenuElementChildren key={menuElement.entity} item={menuElement} />
          ) : (
            <></>
          )}
        </Can>
      ))}
    </Box>
  );
};

export default MenuBasic;
